<template>
  <div class="flex-leave-item">
    <div
      class="flex-item-header h-36 bg-F6F6F6 c-191F25-40 fb fb-main-between fb-cross-center font-26"
    >
      <span>{{ title }}</span>
      <i v-if="needClose" @click="handlerToClose" class="iconfont font-36"
        >&#xe646;</i
      >
    </div>
    <div class="flex-item-content">
      <slot name="content">
        <common-date
          v-if="!boxType"
          :startTime="configs.timeRange.startTime"
          :endTime="configs.timeRange.endTime"
          @time-selection="timeSelection"
        ></common-date>
        <common-select-input-box
          v-else-if="boxType === 1"
          :label="label"
          :label-width="140"
          :value="computedTurnsName"
          :color="true"
          placeholder="未设置"
          class="bg-FFFFFF p-0-16"
          @click="handlerToSelectTurns"
        ></common-select-input-box>
        <div v-else-if="boxType === 2">
          <common-select-input-box
            v-if="!configs.timeList.length"
            :label="label"
            :label-width="140"
            value=""
            :color="true"
            class="bg-FFFFFF p-0-16"
            @click="handlerToSelectTurns"
          ></common-select-input-box>
          <common-dorm-time-line
            v-else
            class="p-0-16"
            :headName="label"
            @headerClick="handlerToSelectTurns"
            :list="computedTimeList"
          ></common-dorm-time-line>
        </div>
        <div v-else-if="boxType === 3 || boxType === 4">
          <common-select-input-box
            v-if="!configs.timeList.length"
            :label="label"
            :label-width="140"
            :value="computedTurnsName"
            :color="true"
            placeholder="请设置"
            class="bg-FFFFFF p-0-16"
            @click="handlerToSelectTurns"
          ></common-select-input-box>
          <common-time-period-line
            v-else
            class="p-0-16"
            :headName="label"
            @headerClick="handlerToSelectTurns"
            :list="computedCallTimeList"
          ></common-time-period-line>
        </div>
        <div v-else-if="boxType === 5">
          <div
            class="wrap bg-FFFFFF p-0-16 p-12-0"
            @click="handlerToSelectTurns"
          >
            <div class="font-34 c-171A1D bg-FFFFFF">{{ label }}</div>
            <div class="font-28 c-171A1D-40 bg-FFFFFF mt-4">
              {{ cpShowTimeRangesText }}
            </div>
          </div>
        </div>
        <div
          class="h-64 font-34 bg-FFFFFF bt p-0-16 fb fb-cross-center fb-main-between relative"
          v-if="configs.weekDays"
        >
          <span class="c-171A1D">星期</span>
          <span
            class="text-center weekday"
            v-for="(itm, idx) in week"
            @click.stop="handlerModifyWeek(itm)"
            :key="idx"
            :class="{
              'c-FFFFFF bg-006AFE': configs.weekDays.indexOf(itm.day) > -1,
              unselected: configs.weekDays.indexOf(itm.day) < 0
            }"
            >{{ itm.name }}</span
          >
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import mixin from '../mixin'
import { throttle } from '@/utils/comUtils'
import commonDate from './commonDate'
import commonDormTimeLine from './commonDormTimeLine'
import commonSelectInputBox from './commonSelectInputBox'
import commonTimePeriodLine from './commonTimePeriodLine'
export default {
  mixins: [mixin],
  components: {
    commonDate,
    commonSelectInputBox,
    commonDormTimeLine,
    commonTimePeriodLine
  },
  props: {
    configs: {
      type: Object,
      default() {
        return {
          timeRange: {
            startTime: '00:00',
            endTime: '23:59'
          },
          weekDays: [],
          teachers: [],
          name: '',
          timeList: []
        }
      }
    },
    needClose: {
      type: Boolean,
      default: false
    },
    currentIndex: {
      type: Number,
      default: 0
    },
    boxType: {
      type: [String, Number],
      default: 0
    },
    label: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      week: [
        {
          name: '一',
          day: 1
        },
        {
          name: '二',
          day: 2
        },
        {
          name: '三',
          day: 3
        },
        {
          name: '四',
          day: 4
        },
        {
          name: '五',
          day: 5
        },
        {
          name: '六',
          day: 6
        },
        {
          name: '日',
          day: 0
        }
      ]
    }
  },
  computed: {
    computedTurnsName() {
      /* eslint-disable */
      return this.configs.teachers
        ? this.configs.teachers
            .reduce((name, next) => {
              return name.concat(next.name)
            }, [])
            .join('、')
        : ''
      /* eslint-enable */
    },
    computedTimeList() {
      return (
        this.configs.timeList &&
        this.configs.timeList.reduce((_list, item) => {
          const { signStartTime, signEndTime, inOutType } = item.timeRange
          return _list.concat({
            startTime: signStartTime,
            endTime: signEndTime,
            type: inOutType,
            isNextDay:
              +signStartTime.replace(':', '') >= +signEndTime.replace(':', '')
          })
        }, [])
      )
    },
    computedCallTimeList() {
      return (
        this.configs.timeList &&
        this.configs.timeList.reduce((_list, item) => {
          return _list.concat({
            ...item.timeRange
          })
        }, [])
      )
    },
    cpShowTimeRangesText() {
      const list = this.configs.timeList || []
      const times = list.map(item =>
        item.startTime === '00:00' && item.endTime === '23:59'
          ? '全天'
          : `${item.startTime}~${item.endTime}`
      )
      return times.join(' ')
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    this.$store.commit('orgSandboxId', '')
  },
  destroyed() {},
  methods: {
    handlerModifyWeek(item) {
      throttle(() => {
        this.$emit('weekChange', {
          index: item.day,
          currentIndex: this.currentIndex
        })
      }, 200)()
    },
    timeSelection(result) {
      this.$emit('timeChange', result, this.currentIndex)
    },
    handlerToClose() {
      this.$emit('close', this.currentIndex)
    },
    handlerToSelectTurns() {
      if (this.boxType === 1) {
        // 设置选中的
        let _selected = this.configs.teachers.reduce((_list, next) => {
          return _list.concat(next.userId)
        }, [])
        setTimeout(() => {
          let _addressBook = {
            title: '请选择值周老师',
            sandboxId: this.$store.getters.orgSandboxId,
            multiple: true,
            returnType: 6,
            selectedMemberIds: _selected
          }
          this.$orgBook(_addressBook)
            .then(res => {
              if (res.$type !== 'onlyReturn') {
                let _members = (res.members || []).map(item => {
                  return {
                    name: item.userName,
                    dingUserId: item.userTpId,
                    userId: item.userId
                  }
                })
                _members.length &&
                  this.$emit('choose', _members, this.currentIndex)
              }
            })
            .catch(err => {
              console.log(err)
            })
        }, 100)
      } else {
        this.$emit('choose', this.currentIndex)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-leave-item {
  .flex-item-header {
    padding: 9px 16px;
    font-weight: 400;
  }
  .flex-item-content {
    .weekday {
      width: 28px;
      height: 28px;
      border-radius: 14px;
      line-height: 28px;
      &.unselected {
        // border: 1px solid rgba(0, 137, 255, 0.6);
        border: 1px solid #006afe;
        color: #006afe;
      }
    }
  }
  .wrap {
    position: relative;
    padding-right: 36px;
    &::after {
      position: absolute;
      font-family: 'iconfont';
      content: '\e68d';
      color: rgba(17, 31, 44, 0.4);
      font-size: 16px;
      top: 50%;
      transform: translateY(calc(-50% + 2px));
      right: 12px;
    }
  }
}
</style>
